import React from 'react';

import { CONFIGURATOR_BREAKPOINTS, CONFIGURATOR_FULLSCREEN_BREAKPOINT } from '../constants';
import { ConfiguratorBreakpoint, ConfiguratorBreakpointClickHandler, ConfiguratorContextBreakpoint } from '../types';

export function useBreakpoints() {
  const [breakpoint, setBreakpoint] = React.useState<ConfiguratorBreakpoint>(CONFIGURATOR_FULLSCREEN_BREAKPOINT);

  const handleBreakpointClick = React.useCallback<ConfiguratorBreakpointClickHandler>((nextBreakpoint) => {
    setBreakpoint(nextBreakpoint);
  }, []);

  const breakpoints = React.useMemo<ConfiguratorContextBreakpoint[]>(() => {
    return CONFIGURATOR_BREAKPOINTS.map((configuratorBreakpoint) => ({
      ...configuratorBreakpoint,
      active: configuratorBreakpoint.id === breakpoint.id,
      onClick: () => handleBreakpointClick(configuratorBreakpoint),
    }));
  }, [breakpoint, handleBreakpointClick]);

  return React.useMemo(() => ({ breakpoint, breakpoints }), [breakpoint, breakpoints]);
}
